<template>
  <transition name="fade">
    <button class="scrollToTop" @click="scrollToTop" v-if="isButtonVisible()">
      <span class="ico"></span>
    </button>
  </transition>
</template>

<script>
import { ToolsClass } from '@/common/class/tools.class'

const MIN_SCROLL_POSITION = 50
export default {
  name: 'ScrollToTop',
  props: ['position'],
  methods: {
    isButtonVisible () {
      return this.position && parseInt(this.position) > MIN_SCROLL_POSITION
    },
    scrollToTop () {
      ToolsClass.scrollToTop()
    }
  }
}
</script>
